import { useRef, useState } from 'react';
import { useFrame } from '@react-three/fiber';
import { Html } from '@react-three/drei';
import * as THREE from 'three';
import { useStore } from '../../../store/useStore';

interface FishingSpotProps {
    position: [number, number, number];
    onInteract: () => void;
    label?: string;
}

export const FishingSpot = ({ position, onInteract, label = "Fish Here" }: FishingSpotProps) => {
    const [hovered, setHovered] = useState(false);
    const ringRef = useRef<THREE.Mesh>(null);

    useFrame((state) => {
        if (ringRef.current) {
            // Pulse effect
            const t = state.clock.elapsedTime;
            const s = 1 + Math.sin(t * 2) * 0.2;
            ringRef.current.scale.set(s, s, 1); // Plane is rotated, so Z is up in scaling relative to mesh
        }
    });

    return (
        <group position={position}>
            {/* Visual Ring on Water */}
            <mesh
                ref={ringRef}
                rotation={[-Math.PI / 2, 0, 0]}
                position={[0, 0.1, 0]} // Slightly above water (-4 + 0.1 = -3.9 if pos is correct)
                onClick={(e) => { e.stopPropagation(); onInteract(); }}
                onPointerOver={() => setHovered(true)}
                onPointerOut={() => setHovered(false)}
            >
                <ringGeometry args={[0.5, 0.7, 32]} />
                <meshBasicMaterial color={hovered ? "white" : "cyan"} transparent opacity={0.5} side={THREE.DoubleSide} />
            </mesh>

            {/* Floating Label */}
            {hovered && (
                <Html position={[0, 1.5, 0]} center distanceFactor={10}>
                    <div style={{
                        background: 'rgba(0,0,0,0.6)',
                        color: 'white',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        pointerEvents: 'none'
                    }}>
                        {label}
                    </div>
                </Html>
            )}
        </group>
    );
};
